import { configureStore, combineReducers, Action } from '@reduxjs/toolkit';
import commonReducer from '../common/commonSlice';
import drawReducer from '../modules/draw/drawSlice';

const appReducer = combineReducers({
  common: commonReducer,
  draw: drawReducer
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: Action) => {
  if (action.type === 'LOG_OUT') {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore canvas element in serialization checks
        ignoredPaths: ['draw.canvas'],
        ignoredActions: ['draw/setCanvas']
      }
    }),
  devTools: import.meta.env.DEV
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
